/**
 * Converts decimal to percent.
 * Example: 0.3 (input) -> 30 (output)
 */
export function decimalToPercent(decimal: number): number {
    return decimal * 100;
}

/**
 * Converts percent to decimal.
 * Example: 30 (input) -> 0.3 (output)
 */
export function percentToDecimal(percent: number): number {
    return percent / 100;
}
